import { cn } from "@sylviq/ui-react-web/lib/cn";
import type { HTMLAttributes, ReactNode } from "react";

export interface HeaderProps extends HTMLAttributes<HTMLElement> {
  left?: ReactNode;
  center?: ReactNode;
  right?: ReactNode;
}

/**
 * Fixed app-header shell. Transparent by design — a positioning area for
 * components, not a surface. Page content must offset for its height (see
 * `.app-header-offset`). All spacing overridable via className.
 */
export function Header({ left, center, right, className, children, ...props }: HeaderProps) {
  return (
    <header className={cn("app-header", className)} {...props}>
      <div className="app-header__slot app-header__left">{left}</div>
      <div className="app-header__slot app-header__center">
        {center}
        {children}
      </div>
      <div className="app-header__slot app-header__right">{right}</div>
    </header>
  );
}
